import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DeveloperChangeRequests from "./DeveloperChangeRequests";
import SystemChangeRequests from "./SystemChangeRequests";

function Requests() {
  const navigate = useNavigate();
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  //Route Access Protection
  useEffect(() => {
    if (!safyInfo?.user?.modules || !safyInfo.user.divisions) {
      navigate("/");
    }

    if (
      safyInfo.user.modules.includes("Team Caseload") !== true &&
      safyInfo.user.modules.includes("Admin") !== true
    ) {
      navigate("/");
    }
  });

  useEffect(() => {
    document.title = "SAFY Portal - Requests";
    return () => {
      document.title = "SAFY Portal";
    };
  }, []);

  useEffect(() => {}, []);

  return (
    <>
      <SystemChangeRequests />
      <DeveloperChangeRequests />
    </>
  );
}

export default Requests;
